import { Component, inject, OnInit, signal } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ConfigService } from 'src/app/services/config.service';
import { DefaultService } from 'src/app/utils/api';
import { Notification } from '../hotline/hotline.component';
import moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationDetailModalComponent } from 'src/app/components/modals/hotlines/notification-detail-modal/notification-detail-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-hotline-dashboard',
    templateUrl: './hotline-dashboard.component.html',
    styleUrl: './hotline-dashboard.component.scss',
    standalone: false
})
export class HotlineDashboardComponent implements OnInit {
    configService = inject(ConfigService);
    defaultService = inject(DefaultService);
    modalService = inject(NgbModal);
    router = inject(Router);
    route = inject(ActivatedRoute);
    toastr = inject(ToastrService);

    appOverviewUrl: string;
    showMax: number = 10;
    RPP: number = 10;
    totalRows: number;
    startRow: number = 0;

    ready: boolean = false;
    loading: boolean = false;
    showAll: boolean = false;

    tableHeads: {
        name: string;
        code: string;
        sortable: boolean;
        width?: string;
    }[] = [
        { name: '', code: 'selected', sortable: false, width: '4%' },
        { name: 'Ervaring', code: 'ervaringIndicator', sortable: false, width: '8%' },
        { name: 'Medicijn', code: 'medicijn', sortable: false, width: '30%' },
        { name: 'Melding', code: 'ervaringDescr', sortable: false, width: '40%' },
        { name: 'Aangemaakt op', code: 'createTS', sortable: false, width: '8%' },
        { name: '', code: 'actions', sortable: false, width: '10%' }
    ];

    data: Notification[] = [];

    bulkSelectedIds = new Set<string>();

    ngOnInit() {
        this.appOverviewUrl = this.configService.getConfig().appOverviewUrl;
        this.getHotlines();
        const detailId = this.route.snapshot.queryParamMap.get('notificationID');
        if (detailId) this.openDetail(detailId);
    }

    async getHotlines() {
        this.loading = true;
        const notifications = await lastValueFrom(
            this.defaultService.notificationsGetNotifications(this.startRow, this.RPP, undefined, false)
        );

        this.totalRows = notifications.rows;
        this.data = notifications?.data.map((notification) => {
            const actions = [];

            return {
                ...notification,
                id: notification.id,
                selected: {
                    type: 'checkbox',
                    value: false // default unchecked
                },
                ervaringIndicator: {
                    type: 'icon',
                    iconPath: `/assets/img/icons/experience_score-${notification.ervaringIndicator}.svg`,
                    classList: 'fontweight-500 text-color experience-icon'
                },
                medicijn: {
                    type: 'default',
                    classList: 'text-color',
                    value: notification.medicijn
                },
                ervaringDescr: {
                    type: 'default',
                    value: notification.ervaringDescr
                },
                createTS: {
                    type: 'default',
                    value: moment(notification.createTS).format('DD-MM-YYYY')
                },
                actions: {
                    type: 'app-button',
                    actions: {
                        classes: 'primary-default button-size--xs ml-auto',
                        text: 'Bekijk'
                    }
                }
            } as Notification;
        });

        this.loading = false;
        this.ready = true;
    }

    openDetail(id: string) {
        this.router.navigate([], {
            queryParams: {
                notificationID: id
            },
            queryParamsHandling: 'merge'
        });

        const modalRef = this.modalService.open(NotificationDetailModalComponent, {
            windowClass: 'main-modal detail-modal',
            beforeDismiss: () => {
                return modalRef.componentInstance.canExit && modalRef.componentInstance.canExit();
            }
        });

        modalRef.dismissed.subscribe({
            next: (next) => {
                this.router.navigate([], {
                    queryParams: {
                        notificationID: undefined
                    },
                    queryParamsHandling: 'merge'
                });
            }
        });

        modalRef.closed.subscribe({
            next: (next) => {
                this.router.navigate([], {
                    queryParams: {
                        notificationID: undefined
                    },
                    queryParamsHandling: 'merge'
                });
                this.getHotlines();
            }
        });
    }

    bulkDelete() {
        this.loading = true;
        const payload = Array.from(this.bulkSelectedIds);
        this.defaultService.notificationsDeleteNotifications(payload).subscribe({
            next: (next) => {
                this.bulkSelectedIds.clear();
                this.toastr.success('Meldingen werden succesvol verwijderd', 'Meldingen verwijderd');
                this.getHotlines();
            }
        });
    }

    toggleChecked(item: any) {
        this.data = this.data.map((x) => {
            if (x.id === item.id) {
                //bulkSelectedIds
                const checked = item.selected.value;
                checked ? this.bulkSelectedIds.add(item.id) : this.bulkSelectedIds.delete(item.id);
                return item;
            }
            return x;
        });
    }

    setStartRow($event) {
        this.startRow = $event;
        this.getHotlines();
    }
}
